import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';
@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css']
})
export class DeleteAccountComponent {
  deleteAccountForm: FormGroup;
  isDeleted: boolean = false;

  constructor(private formBuilder: FormBuilder, public shared: SharedService, public apiService: ApiServiceService) {
    this.deleteAccountForm = this.formBuilder.group({
      confirm_delete: ['', [Validators.required, Validators.pattern(/^DELETE$/)]]
    });
    this.shared.isWhiteMenu = true;
  }

  async onSubmit() {
    // console.log("on onSubmit")
    if (this.deleteAccountForm.valid) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.DELETE_SELLER, {});
      if (res && !res.error) {
        this.isDeleted = true;
      }
    }
  }
}
